import React, {Component} from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import {CenterLoading, decodeTool} from "../App";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardMedia from "@mui/material/CardMedia";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import {Link} from "react-router-dom";
import {NewReleasesSharp} from "@mui/icons-material";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import {Pagination} from "@mui/material";

export default class NewAnime extends Component {

    componentDidMount() {
        document.getElementById("actionBar").style.display = "block";
    }

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            data: [],
            error: false,
            animePage: 1
        };
        this.prepare();
    }

    checkTheme = () => {
        if (localStorage.getItem("darkMode") == null) {
            return true;
        } else {
            if (localStorage.getItem("darkMode").includes("true")) {
                return true;
            } else {
                return false;
            }
        }
    }
    prepare = async () => {
        const isLoggedIn = localStorage.getItem("logged") !== null;
        let url = "";
        var visit = 0;
        visit = await window.react.getVisitCountSync();
        if (isLoggedIn) {
            const data = JSON.parse(localStorage.getItem("loggedData"));
            url = `https://app.sanime.net/function/h10.php?page=latest&email=${data.email}`+"&visit="+visit;
        } else {
            url = `https://app.sanime.net/function/h10.php?page=latest`+"&visit="+visit;;
        }
        fetch(url).then((value) => {
            value.text().then((value) => {
                localStorage.setItem("latestAnime",value);
                let JS = JSON.parse(value);
                this.setState({
                    data: JS['anime'].array_chunk(30),
                    loading: false
                });
            });
        }).catch((error) => {
            this.setState({
                loading: false,
                error: true
            });
        });
        window.react.setState({
            homeTitle: "الأنميات الجديدة"
        });
    }

    restartPage = () => {
        this.setState({
            loading: true,
            error: false
        });
        setTimeout(()=> {
            this.prepare();
        },500);
    }
    animePageChanged = (event, value) => {
        this.setState({animePage: value});
    }
    render() {
        if (this.state.loading) {
            return <CenterLoading/>
        } else if (this.state.error) {
            return <Box>
                <Container style={{placeContent: 'center',textAlign: 'center',marginTop: '20px'}}>
                    <Card>
                        <NewReleasesSharp style={{margin: "10px"}}/>
                        <CardContent style={this.checkTheme() ? {color: '#ffffff'} : {color: '#000000'}}>
                            توجد مشكلة في الشبكة حاول مجددا
                        </CardContent>
                        <Button onClick={this.restartPage} style={{margin: "8px", backgroundColor: '#03a9f4',color: 'white'}}>
                            أعادة المحاولة
                        </Button>
                    </Card>
                </Container>
            </Box>
        } else {
            return <Box style={{marginTop: '7px'}} height={'100%'}>
                <Grid sx={{ flexGrow: 1 }} container spacing={2}>
                    <Grid item xs={12}>
                        <Grid container justifyContent="center" spacing={1.4}>
                            {this.state.data[this.state.animePage - 1].map(r =>
                                <Grid key={r.id} item>
                                    <Card sx={{ width: 108 }} >
                                        <Link to={'/info?id='+r.id} style={{color: 'unset',cursor: 'unset', textDecoration: 'unset'}}>
                                            <CardActionArea>
                                                <CardMedia
                                                    component="img"
                                                    height="185"
                                                    image={r.image}
                                                    alt={r.name}
                                                />
                                                <Divider sx={{height: 1.2}} color={'#00b2ff'}/>
                                                <Stack style={{paddingRight: '4px',paddingLeft: '4px',paddingBottom: '3px',paddingTop: '1px'}} spacing={0}>
                                                    <Typography style={{textOverflow: "ellipsis",overflow: "hidden",whiteSpace: "nowrap",fontSize: '14px'}}>{r.name}</Typography>
                                                    <Typography style={{textAlign: 'right',fontSize: '14px'}}>{r.status}</Typography>
                                                </Stack>
                                            </CardActionArea>
                                        </Link>
                                    </Card>
                                </Grid>
                            )}
                        </Grid>
                    </Grid>
                </Grid>
                <Pagination style={{margin: '4px'}} siblingCount={0} size="large" color={"primary"} page={this.state.animePage} onChange={this.animePageChanged} count={this.state.data.length} variant="outlined" shape="rounded" />
            </Box>;
        }
    }
}
